import RequestAbstract from "./RequestAbstract";

import helper from "actions/helper";

export default class Visits extends RequestAbstract {
    get link() {
        return this.links.visits;
    }

    async get(clinicId, doctorId, from, to, canceledMode, currentToTime) {
        const statusArr = canceledMode ? ["WI_CANCELED", "WI_REPLACED"] : ["WI_CREATED", "WI_COMPLETED"];

        let dateEnd = to ? helper.date.toStr((new Date(to)).setHours(23, 59)) : helper.date.toStr((new Date(from)).setHours(23, 59));
        if (currentToTime)
            dateEnd = to;

        let dateFrom = from;
        if (dateFrom > new Date() && doctorId)
            dateFrom = new Date().setHours(0, 0);

        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "beginDate", op: ">=", value: helper.date.toStr(dateFrom) },
            { field: "status", op: "@", value: statusArr },
        ];

        if (doctorId)
            arr.push({ field: "doctorId", op: "=", value: doctorId });
        else
            arr.push({ field: "endDate", op: "<=", value: helper.date.toStr(dateEnd) });

        return this.getAllFiltered([arr]);
    }

    async checkVisits(clinicId, doctorId, from, to, currentToTime) {
        const statusArr = ["WI_CREATED", "WI_COMPLETED"];

        let dateEnd = helper.date.toStr((new Date(to)).setHours(23, 59));
        if (currentToTime)
            dateEnd = to;

        let dateFrom = from;

        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "beginDate", op: ">=", value: helper.date.toStr(dateFrom) },
            { field: "status", op: "@", value: statusArr },
            { field: "doctorId", op: "=", value: doctorId },
            { field: "endDate", op: "<=", value: helper.date.toStr(dateEnd) }
        ];

        return this.getAllFiltered([arr]);
    }

    async getLastInspectionForClient(clientId) {
        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "status", op: "=", value: "WI_COMPLETED" },
        ];

        const req = await this.getFiltered(this.link, [arr], [{
            "field": "beginDate",
            "direction": "DESC"
        }], {
            page: 0,
            pageSize: 10000
        });

        const visit = (req?.data || []).find(it => it.medInspections && it.medInspections.length);

        const inspection = visit?.medInspections?.length ? {
            date: visit.beginDate,
            inspectionId: visit.medInspections[0].id,
            inspection: visit.medInspections[0]
        } : false;

        return inspection;
    }

    async getFutureVisitForClients(list) {
        const arr = [
            { field: "clientId", op: "@", value: list },
            { field: "status", op: "=", value: "WI_CREATED" },
            { field: "beginDate", op: ">=", value: helper.date.toStr(new Date()) },
        ];

        const req = await this.getFiltered(this.link, [arr], [{
            "field": "beginDate",
            "direction": "DESC"
        }], {
            page: 0,
            pageSize: 10000
        });
        return req;
    }

    async getForCabinet(clinicId, cabinetId, from, to, canceledMode) {
        const statusArr = canceledMode ? ["WI_CANCELED", "WI_REPLACED"] : ["WI_CREATED", "WI_COMPLETED"];

        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "beginDate", op: ">=", value: helper.date.toStr(from) },
            { field: "endDate", op: "<=", value: helper.date.toStr(to) },
            { field: "status", op: "@", value: statusArr },
            { field: "cabinetId", op: "=", value: cabinetId },
        ];

        return this.getAllFiltered([arr]);
    }

    async getCanceledVisits(clinicId, from, to) {
        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "status", op: "@", value: ["WI_CANCELED"] },
            { field: "beginDate", op: ">=", value: helper.date.toStr(from) },
            { field: "endDate", op: "<=", value: helper.date.toStr(to) },
            { field: "clientId", op: "!=", value: null },
        ];
        return this.getAllFiltered([arr]);
    }

    async getForDoctor(clinicId, doctorId, from, to, canceledMode) {
        const statusArr = canceledMode ? ["WI_CANCELED", "WI_REPLACED"] : ["WI_CREATED", "WI_COMPLETED"];

        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "beginDate", op: ">=", value: helper.date.toStr(from) },
            { field: "endDate", op: "<=", value: helper.date.toStr(to) },
            { field: "status", op: "@", value: statusArr },
            { field: "doctorId", op: "=", value: doctorId },
        ];

        return this.getAllFiltered([arr]);
    }

    getForClient(clientId, sortKey, isCreateMode, status) {
        let statusArr = isCreateMode ? ["WI_CREATED"] : ["WI_CANCELED", "WI_REPLACED", "WI_COMPLETED"];
        if (status)
            statusArr = status;

        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "status", op: "@", value: statusArr },
        ];

        return this.getAllFiltered([arr], this.getSortField(sortKey));
    }

    getForTreatmentTask(clientId, treatmentTaskId) {
        const statusArr = ["WI_CREATED", "WI_COMPLETED"];

        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "treatmentTaskId", op: "=", value: treatmentTaskId },
            { field: "status", op: "@", value: statusArr },
        ];

        return this.getAllFiltered([arr], this.getSortField("-endDate"));
    }

    getForNotAttached(clientId) {
        const statusArr = ["WI_CREATED", "WI_COMPLETED"];

        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "treatmentTaskId", op: "=", value: null },
            { field: "status", op: "@", value: statusArr },
        ];

        return this.getAllFiltered([arr], this.getSortField("-endDate"));
    }

    getForPlanClient(clientId, filterCanceled, filterFuture) {
        const dateEnd = helper.date.clearTime(helper.date.addDays(null, 1));
        const statusArr = ["WI_CREATED", "WI_COMPLETED"];
        if (filterCanceled)
            statusArr.push("WI_CANCELED");

        const arr = [
            { field: "clientId", op: "=", value: clientId },
            { field: "status", op: "@", value: statusArr },
        ];

        if (!filterFuture)
            arr.push({ field: "endDate", op: "<", value: helper.date.toStr(dateEnd) });

        //if (filterCanceled)
        //arr.push({ field: "status", op: "!@", value: ["WI_CANCELED"] });

        return this.getAllFiltered([arr], this.getSortField("-endDate"));
    }

    getBuffer(clinicId) {
        const arr = [
            { field: "domainId", op: "=", value: clinicId },
            { field: "status", op: "!@", value: ["WI_CREATED", "WI_CANCELED", "WI_REPLACED", "WI_COMPLETED", "WI_DUMMY"] },
        ];

        return this.getAllFiltered([arr], this.getSortField("-addedToBuffer"));
    }

    async checkCrashVisits(info) {
        const { doctorId, d1, d2, shifts, repeatType, hourOn, hourOff, onlyTheShift, domainId, info: info2 } = info;
        const date1 = helper.date.setTime(new Date(d1), hourOn);
        const date2 = helper.date.setTime(new Date(d2), hourOff);
        const d1Str = helper.date.toStr(new Date(date1));
        const d2Str = helper.date.toStr(new Date(date2));

        const visitsResp = await this.checkVisits(domainId, doctorId, onlyTheShift ? info2.beginDate : d1, onlyTheShift ? info2.endDate : d2, true);
        const visits = visitsResp?.data || null;

        for (let items of visits) {
            const { beginDate, endDate } = items;
            let check = false;

            if (!shifts && (repeatType === "DAILY")) {
                check = helper.date.intervalExceedsBounds(d1Str, d2Str, beginDate, endDate);
            } else if (!shifts && repeatType === "WEEKLY" && !onlyTheShift) {
                for (let i = 0; i < 4; i++) {
                    const count = 7 * i;
                    const dd1 = new Date(date1);
                    const dd2 = helper.date.setTime(new Date(dd1), hourOff);
                    const tempDate1 = helper.date.toStr(helper.date.addDays(dd1, count));
                    const tempDate2 = helper.date.toStr(helper.date.addDays(dd2, count));

                    check = helper.date.intervalExceedsBounds(tempDate1, tempDate2, beginDate, endDate);
                    if (check)
                        break;
                }
            } else if (onlyTheShift) {
                check = helper.date.intervalExceedsBounds(d1Str, d2Str, beginDate, endDate);
            } else if (shifts) {
                for (let sh of shifts) {
                    const { beginDate: bd } = sh;
                    if (helper.date.equealDates(new Date(bd), new Date(beginDate))) {
                        const dd1 = helper.date.toStr(helper.date.setTime(new Date(bd), hourOn));
                        const dd2 = helper.date.toStr(helper.date.setTime(new Date(bd), hourOff));

                        check = helper.date.intervalExceedsBounds(dd1, dd2, beginDate, endDate);
                    }
                    if (check)
                        break;
                }
            }
            if (check)
                return check;
        }

        return false;

    }

    async checkExistVisits(domainId, doctorId, beginDate, endDate, repeatType) {
        const visitsResp = await this.checkVisits(domainId, doctorId, beginDate, endDate, true);
        const visits = visitsResp?.data || [];

        if (repeatType === "DAILY" && visits.length > 0) {
            return true;
        } else if (repeatType === "WEEKLY") {
            for (let items of visits) {
                const { beginDate: bd } = items;
                const check = helper.date.equealDates(new Date(bd), new Date(beginDate));
                if (check)
                    return true;
            }
        }

        return false;
    }

    async checkExistVisitsBeforeInsert(clinicId, doctorId, beginDate, endDate, id, cabinetId) {
        const date = new Date(beginDate);
        const from = helper.date.toStr(date.setHours(0, 0));
        const to = helper.date.toStr(date.setHours(23, 59));
        const visitsResp = await this.getForDoctor(clinicId, doctorId, from, to);
        const visits = (visitsResp?.data || []).filter(it => it.id !== id).filter(it => it.cabinetId === cabinetId);

        if (visits.length > 0) {
            for (let items of visits) {
                const { beginDate: bd, endDate: ed } = items;
                const intervalExceedsBounds = helper.date.intervalsOverlap(bd, ed, beginDate, endDate);
                if (intervalExceedsBounds)
                    return true;
            }
        }
        return false;
    }

}
